module.exports = __webpack_public_path__ + "img/p3.9d6d357f.png";